import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/mortgage',
  component: () => import('../../routes/Mortgage.svelte'),
  card: {
    id: 'mortgage',
    title: 'Mortgage Estimator',
    description: 'Plan your home purchase with detailed monthly payment and amortization estimates.',
    icon: 'home',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/mortgage',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Mortgage Payment Calculator – Home Loan & Mortgage Rates Calculator',
    description: 'Free mortgage calculator for payment estimates. Calculate home mortgage payments, compare mortgage rates, and view amortization schedules. Supports US, Canada, and UK loan structures. Also useful for refinance and home equity calculations.',
  },
};

export default meta;
